// import { AbstractControl } from '@angular/forms';
 
// export function RequireMatch(control: AbstractControl) {
//     const selection: any = control.value;
//     if (typeof selection === 'string') {
//         return { incorrect: true };
//     }
//     return null;
// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberToStringConvert' })
export class NumberToStringConvert implements PipeTransform {
  transform(input:number) {
    return input.toString();
  }
}
